import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getSubscriptionStatus } from '../services/api';
import PaymentModal from './PaymentModal';
import './PlusPage.css';

function PlusPage() {
  const navigate = useNavigate();
  const username = localStorage.getItem('username');
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  useEffect(() => {
    fetchSubscription();
  }, []);

  const fetchSubscription = async () => {
    try {
      const data = await getSubscriptionStatus(username);
      setSubscription(data);
    } catch (error) {
      console.error('Error fetching subscription:', error);
    } finally {
      setLoading(false);
    }
  };

  const handlePaymentSuccess = () => {
    setShowPaymentModal(false);
    fetchSubscription();
  };

  const isPremium = subscription?.isPremium;

  return (
    <div className="plus-container">
      <div className="plus-header">
        <h1>⭐ Couple Check Plus</h1>
        <p>Choose the plan that works for your relationship journey</p>
        {isPremium && (
          <div className="current-plan-badge">
            ✓ You are on Premium — active until {subscription.endDate}
          </div>
        )}
      </div>

      <div className="plans-grid">

        {/* Free Plan */}
        <div className="plan-card free-plan">
          <div className="plan-header">
            <h2>Free</h2>
            <div className="plan-price">
              <span className="price-amount">KES 0</span>
              <span className="price-period">forever</span>
            </div>
          </div>
          <ul className="plan-features">
            <li>✓ Up to 8 journal entries per month, per partner</li>
            <li>✓ View entries</li>
            <li>✓ Basic search (keyword & date)</li>
            <li>✓ Dark mode</li>
            <li>✓ 3 weekly reports per month</li>
            <li>✓ 1 monthly report per month</li>
            <li className="feature-no">✗ No private entries</li>
            <li className="feature-no">✗ No couple's joint report</li>
            <li className="feature-no">✗ No AI feedback on reports</li>
            <li className="feature-no">✗ No AI profile description</li>
          </ul>
          <div className="plan-footer">
            {!isPremium ? (
              <button className="plan-btn current-btn" disabled>Current Plan</button>
            ) : (
              <button className="plan-btn downgrade-btn" disabled>Free Plan</button>
            )}
          </div>
        </div>

        {/* Premium Plan */}
        <div className="plan-card premium-plan">
          <div className="plan-badge">Most Popular</div>
          <div className="plan-header">
            <h2>Premium</h2>
            <div className="plan-price">
              <span className="price-amount">KES 249</span>
              <span className="price-period">/month</span>
            </div>
          </div>
          <ul className="plan-features">
            <li>✓ Everything in Free</li>
            <li>✓ Unlimited journal entries per partner</li>
            <li>✓ Unlimited weekly & monthly reports</li>
            <li>✓ Couple's joint report</li>
            <li>✓ AI-powered feedback on reports</li>
            <li>✓ AI-generated couple profile description</li>
            <li>✓ Private entries (make entries private/public)</li>
            <li>✓ Priority support</li>
          </ul>
          <div className="plan-footer">
            {loading ? (
              <button className="plan-btn" disabled>Loading...</button>
            ) : isPremium ? (
              <button className="plan-btn active-btn" disabled>✓ Active Plan</button>
            ) : (
              <button className="plan-btn subscribe-btn" onClick={() => setShowPaymentModal(true)}>
                Subscribe — KES 249/mo
              </button>
            )}
          </div>
        </div>
      </div>

      <div className="plus-faq">
        <h3>Frequently Asked Questions</h3>
        <div className="faq-item">
          <h4>How does billing work?</h4>
          <p>You are billed KES 249 monthly via M-Pesa. Your subscription is active for 30 days from payment date.</p>
        </div>
        <div className="faq-item">
          <h4>How do I pay?</h4>
          <p>Enter your M-Pesa phone number and you'll receive a payment prompt on your phone. Enter your PIN to complete.</p>
        </div>
        <div className="faq-item">
          <h4>What happens when my Premium expires?</h4>
          <p>Your account reverts to the Free plan. Your entries and data are never deleted.</p>
        </div>
        <div className="faq-item">
          <h4>Can I cancel?</h4>
          <p>Yes. Simply don't renew when your 30-day period ends. No automatic charges.</p>
        </div>
        <div className="faq-item">
          <h4>Is the entry limit per account or per partner?</h4>
          <p>Per partner. Each partner can make up to 8 entries per month independently. If one partner reaches their limit, the other can still add entries until they reach theirs.</p>
        </div>
      </div>

      {showPaymentModal && (
        <PaymentModal
          username={username}
          onSuccess={handlePaymentSuccess}
          onClose={() => setShowPaymentModal(false)}
        />
      )}
    </div>
  );
}

export default PlusPage;